// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen2_comp__X_FFG"};